import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/esnext.typed-array.to-reversed.js";
import "core-js/modules/esnext.typed-array.to-sorted.js";
import "core-js/modules/esnext.typed-array.with.js";
var moment = require('moment');
import tasksMixin from '@/mixins/tasks.js';
import defaultMixin from '@/mixins/task/default.js';
import settingsMixin from '@/mixins/settings.js';
import { VueEditor } from 'vue2-editor';
var requests = require('@/utils/requests').default;
import VueTribute from 'vue-tribute';
var VueScrollTo = require('vue-scrollto');
import ClickOutside from 'vue-click-outside';
import { ActTaskTransformer } from '@/transformers/ActTaskTransformer';
import optionsMixin from "@/mixins/options";
export default {
  name: 'taskEditModal',
  mixins: [tasksMixin, settingsMixin, defaultMixin, optionsMixin],
  props: {
    task: Object,
    selected_project: [Object, Array],
    isRefresh: {
      type: Boolean,
      default: false
    },
    thread: {
      type: Number,
      default: null
    },
    setShowSearch: Boolean
  },
  components: {
    VueEditor: VueEditor,
    VueTribute: VueTribute,
    userRecordOwner: function userRecordOwner() {
      return import('@/components/kiva/KvUserSelect');
    },
    KvTimeSelect: function KvTimeSelect() {
      return import('@/components/kiva/KvTimeSelectDuration');
    },
    vueMention: function vueMention() {
      return import('@/components/tasks/main/widgets/vue_mention');
    },
    subTasks: function subTasks() {
      return import('@/components/tasks/main/forms/subTasks');
    },
    attachments: function attachments() {
      return import('@/components/tasks/main/attachments');
    },
    noteList: function noteList() {
      return import('@/components/global/kvNoteList');
    },
    KvUser: function KvUser() {
      return import('@/components/kiva/KvUser');
    },
    kvLoading: function kvLoading() {
      return import('@/components/kiva/static/loading');
    }
  },
  directives: {
    ClickOutside: ClickOutside
  },
  data: function data() {
    return {
      buttonsDisabled: false,
      loading: false,
      created: false,
      any_change: false,
      changeNeedRefresh: false,
      timeoutData: null,
      fromVisible: {},
      attachmentsList: [],
      subTasks: [],
      labels: [],
      taskData: {},
      basic_task: {},
      focus: false,
      project_section: [],
      fieldVisible: {
        description: false,
        subTasks: false,
        documents: false,
        dependency: false,
        labels: false
      },
      selectedLabels: [],
      configOptions: {
        plugins: ['clips', 'fontsize', 'fullscreen', 'table', 'inlinestyle'],
        buttonsHide: ['html', 'align', 'strikethrough'],
        buttons: ['redo', 'undo', 'format', 'bold', 'italic', 'lists', 'image', 'file', 'link', 'clips'],
        editor: {
          focus: false,
          height: '200px'
        }
      },
      oldTaskData: {},
      isDependencyFound: false,
      project_type: '1',
      priority: [],
      approval_status: [],
      old_task_status: {},
      is_show_selected_dependency: false,
      dependency_key: 'dependency_key',
      documents_key: 'documents_key',
      modal_key: 'modal_key',
      show_selected_dependency: {},
      selected_time_entry: {},
      is_show_time_entry: false,
      time_entry_key: 'time_entry_key',
      oldDescription: '',
      taskContentChanged: null,
      typeOptions: [{
        value: 1,
        label: 'Task'
      }, {
        value: 2,
        label: 'Approval'
      }, {
        value: 3,
        label: 'Issue'
      }]
    };
  },
  methods: {
    scrollTo: function scrollTo(id) {
      var options = {
        container: '#commentsContainer',
        easing: 'ease-in',
        offset: -10,
        force: true
      };
      var duration = 500;
      VueScrollTo.scrollTo("#commentField", duration, options);
    },
    triggerSaveTask: function triggerSaveTask() {
      this.startSaveTask();
    },
    startSaveTask: function startSaveTask() {
      if (this.taskData.record_id) {
        if (typeof this.taskData.task_status != 'undefined' && (this.taskData.task_status.value == 3 || this.taskData.task_status == 3)) {
          this.change_task_to_completed();
        } else {
          this.save_task(_objectSpread(_objectSpread({}, this.taskData), {}, {
            selectedLabels: this.selectedLabels
          }), 'standart', this.isRefresh, this.task);
          this.oldTaskData = _objectSpread({}, this.taskData);
        }
      }
    },
    showField: function showField(field) {
      this.fieldVisible[field] = true;
    },
    findVisibility: function findVisibility(type) {
      if (type == 'description') {
        return !this.taskData.description && !this.fieldVisible.description ? true : false;
      } else if (type == 'sub_tasks') {
        return this.taskData.sub_tasks == '0/0' && !this.fieldVisible.sub_tasks ? true : false;
      } else if (type == 'dependency') {
        return this.taskData.dependency_count == '0/0' && !this.fieldVisible.dependency ? true : false;
      } else if (type == 'documents') {
        return !this.fieldVisible.documents ? true : false;
      } else if (type == 'labels') {
        return !this.fieldVisible.labels ? true : false;
      }
    },
    deleteConfirm: function deleteConfirm() {
      var _this = this;
      this.$confirm(this.$t('This will permanently delete the task'), this.$t('Warning'), {
        confirmButtonText: this.$t('OK'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this.taskData.task_status.value = 4;
        _this.delete_task(_this.taskData);
        _this.$message({
          type: 'success',
          message: _this.$t('Delete completed')
        });
        delete _this.task;
        Object.assign(_this.task, {
          removed: true,
          record_id: null,
          subject: '',
          project: {
            value: null
          },
          record_owner: {
            value: null
          }
        });
        _this.$emit('setEvent', {
          command: 'filter'
        });
        _this.changeNeedRefresh = true;
        _this.set_updates(true);
      }).catch(function (err) {
        _this.$message({
          type: 'info',
          message: _this.$t('Delete canceled')
        });
      });
    },
    find_project_type: function find_project_type() {
      var project = this.taskData.project ? this.taskData.project.value : '';
      var projects = this.$store.state.project.projects_formated;
      var ptype = projects.filter(function (k) {
        return k.id == project;
      });
      this.project_type = ptype[0] ? ptype[0].time_entry_req : '??';
      this.taskData.project_type = this.project_type;
    },
    start_add_time_entry: function start_add_time_entry() {
      this.selected_time_entry = {};
      this.is_show_time_entry = !this.is_show_time_entry;
      this.time_entry_key = Math.random(100);
      this.changeNeedRefresh = true;
    },
    save_task_first_time: function save_task_first_time() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // console.log("attachmentsList save_task_first_time",this.attachmentsList) 
              _this2.taskData.attachmentsList = _this2.attachmentsList;
              _context.next = 3;
              return _this2.save_task(_this2.taskData, 'standart', _this2.isRefresh, _this2.task);
            case 3:
              _this2.setButtonDisabled();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    save_task_first_time_forced: function save_task_first_time_forced() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this3.taskData.subject) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return _this3.save_task(_this3.taskData, 'standart', _this3.isRefresh, _this3.task);
            case 3:
              _context2.next = 6;
              break;
            case 5:
              _this3.$message({
                message: _this3.$t('Subject field should not be null.'),
                type: 'warning'
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    change_task_to_completed: function change_task_to_completed() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var old_task_status;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              old_task_status = _this4.taskData.task_status;
              _this4.changeNeedRefresh = true;
              _this4.taskData.task_status = {
                value: '3',
                label: _this4.$t('Completed')
              };
              _this4.old_task_status = old_task_status;
              _context3.next = 6;
              return _this4.save_task(_this4.taskData, 'standart', _this4.isRefresh, _this4.task);
            case 6:
              _this4.set_updates(true);
              //   this.set_updates();
              _this4.setButtonDisabled();
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setButtonDisabled: function setButtonDisabled() {
      var _this5 = this;
      this.buttonsDisabled = true;
      setTimeout(function () {
        _this5.buttonsDisabled = false;
      }, 1000);
    },
    change_task_to_open: function change_task_to_open() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var old_task_status, params;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              old_task_status = _this6.taskData.task_status;
              _this6.changeNeedRefresh = true;
              _this6.taskData.task_status = {
                value: '1',
                label: _this6.$t('Open')
              };
              _this6.old_task_status = old_task_status;
              // await this.save_task(this.taskData, 'standart', this.isRefresh, this.task)
              // this.set_updates()
              params = {
                task_status: 1,
                record_id: _this6.taskData.record_id
              };
              _context4.next = 7;
              return new KivaProxy({
                endpoint: 'act/task'
              }).update(params).then(function (data) {
                if (data.success == true) {
                  _this6.$store.commit("savingEnd", {
                    status: 2,
                    result: {
                      app: 'act',
                      modul: 'task',
                      recordId: params.record_id,
                      time: moment().format("DD-MM-YYYY HH:mm:ss")
                    }
                  });
                }
                _this6.setButtonDisabled();
              }).catch(function (err) {});
            case 7:
              return _context4.abrupt("return", _context4.sent);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    set_updates: function set_updates(force) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var r;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (_this7.created) {
                r = Math.floor(Math.random() * 1000);
                if (force && _this7.changeNeedRefresh) {
                  _this7.$emit('updateKey', 'k' + r);
                }
                if (_this7.task.setActivityDrawer) {
                  _this7.$store.state.app.activityDrawer = true;
                }
                // await this.startSaveTask()

                if (_this7.changeNeedRefresh == true) {
                  _this7.$emit('updateKey', 'k' + r);
                  setTimeout(function () {
                    _this7.$emit('updateShow', false);
                    if (!_this7.task.setActivityDrawer) {
                      _this7.$emit('setShowSearch', _this7.setShowSearch);
                    }
                  }, 500);
                } else {
                  _this7.$emit('updateShow', false);
                }
                _this7.created = false;
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    get_project_section: function get_project_section(change) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var projects_formated, pr, project_section;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.project_section = [];
              if (!(_this8.taskData.project && _this8.taskData.project.value)) {
                _context6.next = 9;
                break;
              }
              projects_formated = _this8.$store.state.project.projects_formated;
              pr = projects_formated.find(function (k) {
                return k.id == _this8.taskData.project.value;
              });
              _this8.taskData.project.name = pr ? pr.label : '?';
              _context6.next = 7;
              return requests.get_project_section({
                project: _this8.taskData.project.value
              });
            case 7:
              project_section = _context6.sent;
              _this8.project_section = project_section.records;
            case 9:
              _context6.next = 11;
              return _this8.find_project_type();
            case 11:
              // if project changed, it makes section null
              if (change) {
                _this8.taskData.section = {
                  value: null
                };
              }
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    total_time: function total_time() {
      var all = this.all_time_entries;
      var total = 0;
      if (all && _typeof(all) == 'object') {
        all.forEach(function (e) {
          var h = e.hours * 60;
          var m = e.minutes;
          total += h + m;
        });
      }
      var to = Math.floor(total / 60);
      var mi = Math.floor(total - to * 60);
      var ho = to ? to + 's ' : '';
      var min = mi ? mi + 'dk. ' : '';
      return ho + ' ' + min;
    },
    get_labels: function get_labels() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              new KivaProxy({
                endpoint: 'act/task_label'
              }).all().then(function (response) {
                _this9.labels = response.records;
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    get_task: function get_task(taskId) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return new KivaProxy({
                endpoint: 'act/task'
              }).find(taskId).then(function (response) {
                _this10.taskData = ActTaskTransformer.fetch(response.record);
              });
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    starter: function starter() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var projects;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this11.oldDescription = _this11.taskData.description;

              //If projects havent yet stored, start to get projects
              if (!(_this11.projects && (!_this11.projects[0] || _this11.projects && !_this11.projects[0]))) {
                _context9.next = 7;
                break;
              }
              _context9.next = 4;
              return requests.get_projects({
                project_status: 1
              });
            case 4:
              projects = _context9.sent;
              projects = projects.records;
              _this11.projects = projects;
            case 7:
              if (!_this11.taskData.project) {
                if (_this11.selected_project && _this11.selected_project.record_id) {
                  _this11.taskData.project = {
                    value: '' + _this11.selected_project.record_id,
                    label: '' + _this11.selected_project.project_name,
                    name: '' + _this11.selected_project.project_name
                  };
                } else {
                  _this11.taskData.project = {
                    value: null
                  };
                }
              }
              if (_this11.taskData.record_id && _this11.taskData.record_id != '') {
                _this11.list_notes();
                _this11.list_time_entries(_this11.taskData.record_id);
              }
              _this11.get_labels();
              _this11.get_project_section(false);
              if (_this11.taskData.dependency && _this11.taskData.dependency.value && _this11.taskData.dependency.value != '') {
                _this11.taskData.dependency = _this11.taskData.dependency.value;
              }
              setTimeout(function () {
                _this11.loading = false;
              }, 350);
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    dataUriToBlob: function dataUriToBlob(dataURI) {
      // serialize the base64/URLEncoded data
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }

      // parse the mime type
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // construct a Blob of the image data
      var array = [];
      for (var i = 0; i < byteString.length; i++) {
        array.push(byteString.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], {
        type: mimeString
      });
    }
  },
  computed: {
    users: function users() {
      return this.$store.state.users.USERS;
    },
    me: function me() {
      return _objectSpread({}, this.$store.state.users.CURRENT_USER);
    },
    projects: {
      get: function get() {
        return this.$store.state.project.projects;
      },
      set: function set(val) {
        this.$store.state.project.projects = val;
      }
    },
    editable: function editable() {
      return this.taskData.task_status && (this.taskData.task_status.value == 3 || this.taskData.task_status == 3) ? false : true;
    },
    task_status: {
      get: function get() {
        return this.$store.state.task_status;
      },
      set: function set(val) {
        // console.warning("Can not set task status!")
        // this.$store.state.task_status = val
      }
    }
  },
  created: function created() {
    var _this12 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var img, blob;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _this12.loading = true;
            moment.locale(_this12.$locale);
            _context10.next = 4;
            return _this12.getOptions({
              app: 'act',
              model: 'task',
              column: 'task_status'
            });
          case 4:
            _context10.next = 6;
            return _this12.getOptions({
              app: 'act',
              model: 'task',
              column: 'approval_status'
            });
          case 6:
            _context10.next = 8;
            return _this12.getOptions({
              app: 'act',
              model: 'task',
              column: 'priority'
            });
          case 8:
            if (!_this12.task) {
              _context10.next = 21;
              break;
            }
            if (!_this12.task.record_id) {
              _context10.next = 14;
              break;
            }
            _context10.next = 12;
            return _this12.get_task(_this12.task.record_id);
          case 12:
            _context10.next = 18;
            break;
          case 14:
            _this12.set_basic_task_data();
            _this12.taskData = _objectSpread({}, _this12.basic_task);
            if (_this12.task && _this12.task.description) {
              _this12.taskData.description = _this12.task.description;
            }
            if (_this12.task.attachment) {
              img = _this12.task.attachment;
              blob = _this12.dataUriToBlob(img);
              blob.name = 'captured_screenshot.png';
              _this12.attachmentsList = [blob];
              _this12.showField('documents');
            }
          case 18:
            _this12.oldTaskData = _objectSpread({}, _this12.taskData);
            _context10.next = 23;
            break;
          case 21:
            _this12.set_basic_task_data();
            _this12.taskData = _objectSpread({}, _this12.basic_task);
          case 23:
            setTimeout(function () {
              _this12.created = true;
            }, 300);
            if (_this12.thread) {
              _this12.taskData.thread = _this12.thread;
              _this12.oldTaskData.thread = _this12.thread;
            }
            _this12.starter();
          case 26:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }))();
  },
  watch: {
    'taskData.description': function taskDataDescription(val) {
      var _this13 = this;
      if (val != this.oldDescription && this.oldDescription != '' && this.taskData.record_id) {
        var nowMS = new Date();
        if (!this.taskContentChanged) {
          this.taskContentChanged = new Date();
        }
        var diff = nowMS.getTime() - this.taskContentChanged.getTime();
        if (diff > 600) {
          if (this.timeoutData) {
            clearTimeout(this.timeoutData);
          }
          this.startSaveTask();
        } else {
          this.timeoutData = setTimeout(function () {
            _this13.startSaveTask();
          }, 1000);
        }
        // console.log(this.taskContentChanged,nowMS,diff)
        this.taskContentChanged = nowMS;
      }
    }
  }
};